// Tire compound table. Each compound trades grip against wear rate
// AND has its own preferred temperature window — softer compounds
// like it hot, harder compounds work cooler. Compound names are
// stable strings; adding a new compound (e.g., 'wet' once weather
// modeling lands) requires only a new entry here plus authoring it
// in a car spec.
//
// gripMul         — multiplier on `spec.grip` / `spec.tractionGrip`.
//                   Applied before the tire-life and temp curves, so
//                   a fresh-warm soft beats a fresh-warm medium, and a
//                   worn soft is roughly equivalent to a fresh medium
//                   (the tradeoff that drives compound strategy).
// wearRate        — multiplier on the base wear function. 1.0 =
//                   baseline (medium); >1 wears faster.
// tempColdLimit   — °C below which the compound bottoms out at its
//                   cold-grip floor. Lap 1 territory.
// tempOptimalLow  — °C at which the grip curve hits its 100 % plateau.
// tempOptimalHigh — °C at which the plateau ends; above this the tire
//                   starts to grease up.
// tempHotLimit    — °C above which grip bottoms out at its hot floor
//                   AND wear rate hits its peak multiplier.
// label           — short human-readable name for the HUD.
//
// Real-world rough analogues (F1 slick range):
//   soft   — works ~95–115 °C, fragile in the cold, hot-tire fast
//   medium — works ~85–105 °C, all-rounder
//   hard   — works ~75–95 °C,  forgiving in the cold, slow to peak
//
// Tuning: deltas below are deliberately tighter than real F1 so
// compound choice matters but doesn't dominate. Widen once gameplay
// testing shows strategy needs more bite.

export const TIRE_COMPOUNDS = {
  soft: {
    label:           'Soft',
    gripMul:         1.05,
    wearRate:        1.50,
    tempColdLimit:    65,
    tempOptimalLow:   95,
    tempOptimalHigh: 115,
    tempHotLimit:    140,
  },
  medium: {
    label:           'Medium',
    gripMul:         1.00,
    wearRate:        1.00,
    tempColdLimit:    55,
    tempOptimalLow:   85,
    tempOptimalHigh: 105,
    tempHotLimit:    130,
  },
  hard: {
    label:           'Hard',
    gripMul:         0.95,
    wearRate:        0.65,
    tempColdLimit:    50,
    tempOptimalLow:   75,
    tempOptimalHigh:  95,
    tempHotLimit:    120,
  },
};

export function getCompound(name) {
  return TIRE_COMPOUNDS[name] || TIRE_COMPOUNDS.medium;
}
